export const AUTH = "AUTH";
export const SPARE_ACCESS_RIGHTS = "SPARE_ACCESS_RIGHTS";
export const TECHNICAL_DOC_ACCESS_RIGHTS = "TECHNICAL_DOC_ACCESS_RIGHTS";
export const ADVISORIES_ACCESS_RIGHTS = "ADVISORIES_ACCESS_RIGHTS";
export const NOTIFICATIONS_ACCESS_RIGHTS = "NOTIFICATIONS_ACCESS_RIGHTS";
export const CLEAN_STATE = "CLEAN_STATE";
export const NOTIFICATION_READ_STATUS = "NOTIFICATION_READ_STATUS";
export const LOGOUT_USER = "LOGOUT_USER";
export const KEY_AND_IV = "KEY_AND_IV";
export const SET_NOTIFICATION_COUNT = "SET_NOTIFICATION_COUNT";
export const SET_ROLL_LIST = "SET_ROLL_LIST";
export const SET_MODEL_SEARCH_BRAND = "SET_MODEL_SEARCH_BRAND";
export const SET_MODEL_SEARCH_BRICK = "SET_MODEL_SEARCH_BRICK";
export const SET_MODEL_SEARCH_MODEL = "SET_MODEL_SEARCH_MODEL";

export const SET_SPARE_SEARCH_VENDOR = "SET_SPARE_SEARCH_VENDOR";
export const SET_SPARE_SEARCH_ACTION = "SET_SPARE_SEARCH_ACTION";
export const SET_SPARE_SEARCH_BRAND = "SET_SPARE_SEARCH_BRAND";
export const SET_SPARE_SEARCH_BRICK = "SET_SPARE_SEARCH_BRICK";
export const SET_SPARE_SEARCH_PTYPE = "SET_SPARE_SEARCH_PTYPE";
export const SET_SPARE_SEARCH_ACTIVE = "SET_SPARE_SEARCH_ACTIVE";
export const SET_SPARE_SEARCH_MODEL = "SET_SPARE_SEARCH_MODEL";
export const SET_SPARE_SEARCH_ARTICLE = "SET_SPARE_SEARCH_ARTICLE";
export const SET_SPARE_SEARCH_DESCR = "SET_SPARE_SEARCH_DESCR";

